import React from 'react';

import PSLIModalForm, { PSLIModalFormProps } from './PSLIModalForm';

const AddPSLIModalForm: React.FC<PSLIModalFormProps> = props => (
  <PSLIModalForm {...props} title="Add a Planned Shipment" submitButtonText="Add" />
);

export default AddPSLIModalForm;
